module.exports = "static/assets/69411ffb5deeadcabaecaf8841c07e31.svg";